<template>
  <div id="videoArea" class="wrapper" :style="{ height: (this.heightData / 600 * 1068) + 'px' }">
    <video ref="video" autoplay muted playsinline class="video" />
    <div class="live-indicator" :class="isLive ? 'live' : 'stale'"></div>
  </div>
</template>

<script>
import mpegts from 'mpegts.js'

export default {
  name: 'videoMonitor',
  data() {
    return {
      heightData: 500,
      lastWidth: 0,
      player: null,
      isLive: true,
      lastUpdate: Date.now(),
      checkInterval: null
    }
  },
  async mounted() {
    const video = this.$refs.video

    if (mpegts.getFeatureList().mseLivePlayback && video) {
      this.player = mpegts.createPlayer({
        type: 'mpegts',
        isLive: true,
        url: `http://100.116.129.27:8080/video`,
        liveSync: true,
        sound: true,
        enableStashBuffer: false
      })

      this.player.attachMediaElement(video)
      this.player.load()
      this.player.play()

      // Güncelleme zamanı
      video.addEventListener('timeupdate', () => {
        this.lastUpdate = Date.now()
      })

      // 500ms'de bir canlılık kontrolü
      this.checkInterval = setInterval(() => {
        this.isLive = (Date.now() - this.lastUpdate) < 1000
      }, 500)
    } else {
      alert('Tarayıcınız MPEG-TS canlı yayını desteklemiyor.')
    }

    const el = document.getElementById('videoArea')
    if (el) {
      this.observer = new ResizeObserver(entries => {
        for (let entry of entries) {
          const newWidth = entry.contentRect.width
          if (Math.abs(this.lastWidth - newWidth) > 1) {
            this.lastWidth = newWidth
            window.requestAnimationFrame(() => {
              this.heightData = newWidth
            })
          }
        }
      })
      this.observer.observe(el)
    }
  },
  beforeUnmount() {
    if (this.player) {
      this.player.destroy()
      this.player = null
    }
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
  }
}
</script>


<style scoped>
.wrapper {
  width: 100%;
  min-height: 250px;
  max-width: 400px !important;
  border: 1px solid red;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.video {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg) scale(1.78);
  transform-origin: center center;
  object-fit: contain;
}

.live-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.live-indicator.live {
  background-color: #00ff00;
  /* yeşil */
}

.live-indicator.stale {
  background-color: #ff0000;
  /* kırmızı */
}
</style>